 //export const liveURL = 'http://localhost:4002/api'
// export const IMAGE_URL = 'http://localhost:4002/'
 export const liveURL = 'https://api.mushtaqanenoor.org/api' 
 export const IMAGE_URL = 'https://api.mushtaqanenoor.org/'
export const ApiKey = 'a9b8f1c6e3d7-c7e6b2a4d3f1c5e7-a9f5f8d1f9'
//export const liveURL = 'https://testapi.mushtaqanenoor.org/api'
//export const IMAGE_URL = 'https://testapi.mushtaqanenoor.org/'